import XLight from '@/assets/xLight.svg';
import Modal from '../../general/Modal';

interface DeleteFolderDialogProps {
  show: boolean;
  folderName: string;
  onOk: () => void;
  onCancel: () => void;
}

export default function DeleteFolderDialog({ show, folderName, onOk, onCancel }: DeleteFolderDialogProps) {
  return (
    <Modal open={show} onClose={onCancel} contanerClassName="w-[500px] max-w-[90vw] bg-white shadow-xl">
      <div className="flex items-center justify-between p-4">
        <h3 className="text-lg font-medium text-gray-900">Delete Folder</h3>
        <XLight className="h-6 w-6 cursor-pointer hover:bg-gray-100" onClick={onCancel} />
      </div>
      <div className="p-4">
        <p className="mb-2 text-gray-900">
          Are you sure you want to delete <strong>{folderName}</strong> folder and contents?
        </p>
        <p className="text-sm text-gray-600">
          Once your folder has been deleted this will be removed from your scrapbook permanently.
        </p>
      </div>
      <div className="flex justify-end gap-3 rounded-b-lg bg-gray-50 p-4">
        <button
          onClick={onOk}
          className="hover:bg-black-700 h-10 min-w-[71px] cursor-pointer rounded-3xl bg-black px-4 py-2 text-white transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-md"
        >
          Ok
        </button>
        <button
          onClick={onCancel}
          className="hover:bg-gray-3 h-10 min-w-[90px] cursor-pointer rounded-3xl bg-[#f5f5f5] px-4 py-2 text-gray-700 transition-all duration-300 ease-in-out hover:scale-105 hover:text-gray-900 hover:shadow-md"
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
}
